// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OptionDropdowns_entry-component-search-box-container__3w6ba{
    position: relative;
    z-index: 0;
    /* margin-top: 26vw; */
    height: 3vw;
    /* margin-left: 19.5vw; */
    border-radius: 100vw;
    padding: 0.1px;
    font-family: dm-sans-light;
    place-content: center;
    cursor: pointer;
    margin-left: 0.7vw;

    /* box-sizing: border-box; */
 }
 
 
 .OptionDropdowns_entry-component-search-box__X7pit{
    height: 3vw;
    border-radius: 100vw;
    align-self: center;
    align-items: center;
    /* margin: 1vw auto auto; */
    cursor: pointer;
    box-sizing: border-box;
    padding-left: 2vw;
    padding-right: 2vw;
    display: flex;
 }
 
 
 .OptionDropdowns_plc-text__ZQx6S{
    font-size: 1.2vw;
    font-family: dm-sans-light;
 }
 
 
 .OptionDropdowns_entry-dropdown-container__AE9jU{
    position: absolute;
    z-index: 5;
    background: white;
    width: 12vw;
    min-height: 4vw;
    height: max-content;
    border-radius: 1vw;
    margin-left: -8.5vw;
    box-sizing: border-box;
    margin-top: 1.5vw;
    overflow: hidden;
    border: 1px solid #e1e1e1;
 }
 
 
 .OptionDropdowns_entry-dropdown-options__mLPBp{
    display: flex;
    height: 2.5vw;
    align-items: center;
    padding-left: 2vw;
    margin: 0;
    margin-top: 0;
    cursor: pointer;
 }
 
 
 .OptionDropdowns_entry-dropdown-options__mLPBp:hover{
    background-color: #f5715a;
    color: white;
 }
 
 
 
 
 @media(max-width: 768px){
    .OptionDropdowns_entry-component-search-box-container__3w6ba{
        /* margin-top: 60vw; */
        position: relative;
        height: 3vh;
        z-index: 2;
        margin-left: 2vw;
        place-content: center;
    }
 
 
    .OptionDropdowns_entry-component-search-box__X7pit{
        width: 80vw;
        height: 12vh;
        background-color: white;
        border-radius: 100vw;
        /* align-self: center; */
        margin-top: 1vw;
        margin-left: 2vw;
    }
 
 
    .OptionDropdowns_plc-text__ZQx6S{
        font-size: 4vw;
    }
 
 
    .OptionDropdowns_entry-dropdown-container__AE9jU{
        background: white;
        width: 50vw;
        height: max-content;
        padding-bottom: 10px;
        border-radius: 4vw;
        margin-left: -50vw;
        box-sizing: border-box;
        margin-top: 5vw;
        overflow: hidden;
    }
   
    .OptionDropdowns_entry-dropdown-options__mLPBp{
        display: flex;
        height: 7vw;
        align-items: center;
        padding-left: 3vw;
        margin: 0;
        margin-top: 0;
    }
 }
 
 `, "",{"version":3,"sources":["webpack://./src/Global/customDropdown/OptionDropdowns.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,UAAU;IACV,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,0BAA0B;IAC1B,qBAAqB;IACrB,eAAe;IACf,kBAAkB;;IAElB,4BAA4B;CAC/B;;;CAGA;IACG,WAAW;IACX,oBAAoB;IACpB,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;CAChB;;;CAGA;IACG,gBAAgB;IAChB,0BAA0B;CAC7B;;;CAGA;IACG,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;CAC5B;;;CAGA;IACG,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,SAAS;IACT,aAAa;IACb,eAAe;CAClB;;;CAGA;IACG,yBAAyB;IACzB,YAAY;CACf;;;;;CAKA;IACG;QACI,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,gBAAgB;QAChB,qBAAqB;IACzB;;;IAGA;QACI,WAAW;QACX,YAAY;QACZ,uBAAuB;QACvB,oBAAoB;QACpB,wBAAwB;QACxB,eAAe;QACf,gBAAgB;IACpB;;;IAGA;QACI,cAAc;IAClB;;;IAGA;QACI,iBAAiB;QACjB,WAAW;QACX,mBAAmB;QACnB,oBAAoB;QACpB,kBAAkB;QAClB,kBAAkB;QAClB,sBAAsB;QACtB,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,mBAAmB;QACnB,iBAAiB;QACjB,SAAS;QACT,aAAa;IACjB;CACH","sourcesContent":[".entry-component-search-box-container{\n    position: relative;\n    z-index: 0;\n    /* margin-top: 26vw; */\n    height: 3vw;\n    /* margin-left: 19.5vw; */\n    border-radius: 100vw;\n    padding: 0.1px;\n    font-family: dm-sans-light;\n    place-content: center;\n    cursor: pointer;\n    margin-left: 0.7vw;\n\n    /* box-sizing: border-box; */\n }\n \n \n .entry-component-search-box{\n    height: 3vw;\n    border-radius: 100vw;\n    align-self: center;\n    align-items: center;\n    /* margin: 1vw auto auto; */\n    cursor: pointer;\n    box-sizing: border-box;\n    padding-left: 2vw;\n    padding-right: 2vw;\n    display: flex;\n }\n \n \n .plc-text{\n    font-size: 1.2vw;\n    font-family: dm-sans-light;\n }\n \n \n .entry-dropdown-container{\n    position: absolute;\n    z-index: 5;\n    background: white;\n    width: 12vw;\n    min-height: 4vw;\n    height: max-content;\n    border-radius: 1vw;\n    margin-left: -8.5vw;\n    box-sizing: border-box;\n    margin-top: 1.5vw;\n    overflow: hidden;\n    border: 1px solid #e1e1e1;\n }\n \n \n .entry-dropdown-options{\n    display: flex;\n    height: 2.5vw;\n    align-items: center;\n    padding-left: 2vw;\n    margin: 0;\n    margin-top: 0;\n    cursor: pointer;\n }\n \n \n .entry-dropdown-options:hover{\n    background-color: #f5715a;\n    color: white;\n }\n \n \n \n \n @media(max-width: 768px){\n    .entry-component-search-box-container{\n        /* margin-top: 60vw; */\n        position: relative;\n        height: 3vh;\n        z-index: 2;\n        margin-left: 2vw;\n        place-content: center;\n    }\n \n \n    .entry-component-search-box{\n        width: 80vw;\n        height: 12vh;\n        background-color: white;\n        border-radius: 100vw;\n        /* align-self: center; */\n        margin-top: 1vw;\n        margin-left: 2vw;\n    }\n \n \n    .plc-text{\n        font-size: 4vw;\n    }\n \n \n    .entry-dropdown-container{\n        background: white;\n        width: 50vw;\n        height: max-content;\n        padding-bottom: 10px;\n        border-radius: 4vw;\n        margin-left: -50vw;\n        box-sizing: border-box;\n        margin-top: 5vw;\n        overflow: hidden;\n    }\n   \n    .entry-dropdown-options{\n        display: flex;\n        height: 7vw;\n        align-items: center;\n        padding-left: 3vw;\n        margin: 0;\n        margin-top: 0;\n    }\n }\n \n "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"entry-component-search-box-container": `OptionDropdowns_entry-component-search-box-container__3w6ba`,
	"entry-component-search-box": `OptionDropdowns_entry-component-search-box__X7pit`,
	"plc-text": `OptionDropdowns_plc-text__ZQx6S`,
	"entry-dropdown-container": `OptionDropdowns_entry-dropdown-container__AE9jU`,
	"entry-dropdown-options": `OptionDropdowns_entry-dropdown-options__mLPBp`
};
export default ___CSS_LOADER_EXPORT___;
